(() => {
  const root = document.querySelector('[data-oe-contact-hub]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const trigger = root.querySelector('[data-oe-contact-trigger]');
  const backdrop = root.querySelector('[data-oe-contact-backdrop]');
  const dialog = root.querySelector('[data-oe-contact-dialog]');
  const closeButton = root.querySelector('[data-oe-contact-close]');
  const chatButton = root.querySelector('[data-oe-contact-chat]');
  const freeRequestButton = root.querySelector('[data-oe-contact-free-request]');
  const icons = [...root.querySelectorAll('[data-oe-contact-icon]')];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const siblings = [];
  let previousOverflow;
  let previousBodyPaddingRight;
  let previousTriggerRight;
  let attentionTimeout;
  let attentionTimer;
  let attentionStarted = false;
  let scrollTimeout;
  let scrollAnchor = window.scrollY;
  let iconIndex = 0;

  const rotateIcon = () => {
    icons[iconIndex].classList.remove('is-active');
    iconIndex = (iconIndex + 1) % icons.length;
    icons[iconIndex].classList.add('is-active');
  };

  const rotateAttention = () => {
    rotateIcon();
    attentionTimer = window.setTimeout(rotateAttention, 4000);
  };

  const startAttention = (immediate = false) => {
    if (reducedMotion.matches || attentionStarted) return;
    if (immediate) {
      window.clearTimeout(attentionTimeout);
      attentionStarted = true;
      rotateAttention();
      return;
    }
    attentionTimeout = window.setTimeout(() => {
      attentionStarted = true;
      rotateAttention();
    }, 10000);
  };

  const setBackgroundInert = (isInert) => {
    if (isInert) {
      for (const sibling of document.body.children) {
        if (sibling === root || sibling.tagName === 'SCRIPT') continue;
        siblings.push([sibling, sibling.inert]);
        sibling.inert = true;
      }
    } else {
      for (const [sibling, wasInert] of siblings) sibling.inert = wasInert;
      siblings.length = 0;
    }
  };

  const open = (touchActivated = false) => {
    if (!dialog.hidden) return;
    window.clearTimeout(scrollTimeout);
    scrollTimeout = undefined;
    scrollAnchor = window.scrollY;
    trigger.setAttribute('aria-expanded', 'true');
    backdrop.hidden = false;
    dialog.hidden = false;
    previousOverflow = document.documentElement.style.overflow;
    previousBodyPaddingRight = document.body.style.paddingRight;
    previousTriggerRight = trigger.style.right;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      const bodyPaddingRight = Number.parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
      document.body.style.paddingRight = `${bodyPaddingRight + scrollbarWidth}px`;
      const triggerRight = Number.parseFloat(window.getComputedStyle(trigger).right) || 0;
      trigger.style.right = `${triggerRight + scrollbarWidth}px`;
    }
    document.documentElement.style.overflow = 'hidden';
    setBackgroundInert(true);
    if (touchActivated) dialog.focus({ preventScroll: true });
    else closeButton.focus({ preventScroll: true });
  };

  const close = (restoreFocus = true) => {
    if (dialog.hidden) return;
    dialog.hidden = true;
    backdrop.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = previousOverflow;
    document.body.style.paddingRight = previousBodyPaddingRight;
    trigger.style.right = previousTriggerRight;
    setBackgroundInert(false);
    if (restoreFocus) trigger.focus();
  };

  trigger.addEventListener('click', (event) => {
    if (dialog.hidden) open(event.detail > 0 && window.matchMedia('(hover: none) and (pointer: coarse)').matches);
    else close();
  });
  trigger.addEventListener('mouseenter', () => startAttention(true));
  closeButton.addEventListener('click', () => close());
  backdrop.addEventListener('click', () => close());

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled])')];
    const first = focusable[0];
    const last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  chatButton.addEventListener('click', async () => {
    close(false);
    if (window.customElements?.whenDefined) {
      await Promise.race([
        window.customElements.whenDefined('shopify-chat'),
        new Promise((resolve) => window.setTimeout(resolve, 1500)),
      ]);
    }
    const chat = document.querySelector('shopify-chat');
    if (chat && typeof chat.show === 'function') chat.show();
    else trigger.focus();
  });

  freeRequestButton?.addEventListener('click', () => {
    close(false);
    window.dispatchEvent(new CustomEvent('oe:free-product-request:open', { detail: { opener: trigger } }));
  });

  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !dialog.hidden) close();
  });

  window.addEventListener('scroll', () => {
    if (!dialog.hidden) return;
    const currentScrollY = window.scrollY;
    if (!scrollTimeout && Math.abs(currentScrollY - scrollAnchor) < 120) return;
    trigger.classList.remove('is-collapsed');
    window.clearTimeout(scrollTimeout);
    scrollTimeout = window.setTimeout(() => {
      trigger.classList.add('is-collapsed');
      scrollAnchor = window.scrollY;
      scrollTimeout = undefined;
    }, 1100);
  }, { passive: true });

  reducedMotion.addEventListener?.('change', () => {
    window.clearTimeout(attentionTimeout);
    window.clearTimeout(attentionTimer);
    attentionStarted = false;
    startAttention();
  });
  startAttention();
})();
